import * as React from 'react';
import * as uuid from 'uuid';
import { uploadVideo } from '../../../cloudinary';
import FileContainer from '../../../components/FileContainer';
import { Link } from '../../../types/api';
import { Application, Document } from '../types';

interface DocumentUploadProps {
    application: Application;
    onDocumentUploaded: (document: Document, link: Link) => void;
}

interface DocumentUploadState {
    uploadState: undefined | 'UPLOADING';
    uploadPercentage: number;
    errorMessage: string | undefined;
}

class DocumentUpload extends React.Component<DocumentUploadProps, DocumentUploadState> {
    constructor(props: DocumentUploadProps) {
        super(props);
        this.state = {
            uploadState: undefined,
            uploadPercentage: 0,
            errorMessage: undefined
        };
        this.handleNewFile = this.handleNewFile.bind(this);
    }

    private async handleNewFile(files: any) {
        const file = files[0];
        try {
            const publicId = await uploadVideo(
                'candidate_document',
                'candidate_documents/' + this.props.application.id,
                file,
                progressPercent => {
                    this.setState({ uploadState: 'UPLOADING', uploadPercentage: progressPercent });
                }
            );
            this.setState({ uploadState: undefined });
            const document: Document = {
                id: uuid.v4(),
                applicationId: this.props.application.id,
                documentReference: publicId,
                documentName: file.name
            };
            this.props.onDocumentUploaded(document, this.props.application._links!.put_document);
        } catch (err) {
            this.setState({ errorMessage: err.errorMessage });
        }
    }

    public render() {
        return (
            <div>
                {this.state.uploadState === undefined ? (
                    <FileContainer>
                        Upload a document file
                        <input id="document_uploads" type="file" onChange={e => this.handleNewFile(e.target.files)} />
                    </FileContainer>
                ) : (
                    <div>Uploading... {this.state.uploadPercentage}%</div>
                )}
                <p>{this.state.errorMessage}</p>
            </div>
        );
    }
}

export default DocumentUpload;



// WEBPACK FOOTER //
// ./src/scenes/candidate/components/DocumentUpload.tsx